import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBc-mtTxhDz37Hb8hltB4QBNQ73ejF1iVE",
  authDomain: "a1-marketsence.firebaseapp.com",
  projectId: "a1-marketsence",
  storageBucket: "a1-marketsence.firebasestorage.app",
  messagingSenderId: "25574047596",
  appId: "1:25574047596:web:9a1aa7007d2d99bf09bd49",
  measurementId: "G-B4H5KDKJEQ"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // This exports your database for use in App.js